/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Slow_PlayInputs */



/**
* | output |
* | --- |
* | "Slow Play" |
*
* @param {Sanction_Sub_Slow_PlayInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_slow_play = /** @type {((inputs?: Sanction_Sub_Slow_PlayInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Slow_PlayInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Jeu Lent")
	if (locale === "es") return /** @type {LocalizedString} */ ("Juego Lento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogo Lento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gioco Lento")
	return /** @type {LocalizedString} */ ("Slow Play")
});